import { makeStyles, useMediaQuery } from '@material-ui/core';
import React, { useState } from 'react';

import { colors } from 'src/themes/colors';
import mobileWarningImage from 'src/assets/images/mobile_warning.svg';

import MHButton from './MHButton';

const useStyles = makeStyles({
  wrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    zIndex: 100,
    backgroundColor: colors.white1,
  },
  innerWrapper: {
    display: 'flex',
    height: '100%',
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 20,
  },
  contentWrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  headingText: {
    textAlign: 'center',
    marginTop: 40,
    fontWeight: 900,
    fontSize: 24,
    color: colors.black1,
  },
  descriptionText: {
    textAlign: 'center',
    fontSize: 16,
    lineHeight: '26px',
    color: colors.black2,
  },
  colorfulText: {
    color: colors.blue3,
    fontWeight: 800,
  },
  buttonWrapper: {
    width: '100%',
  },
  button: {
    fontWeight: 800,
    fontSize: 16,
    width: '100%',
    boxShadow: '0px 8px 12px rgba(183, 186, 190, 0.5)',
  },
});

export const MobileDeviceWarning: React.FC = () => {
  const [visible, setVisible] = useState(true);
  const smartphoneDetected = useMediaQuery('(max-width:500px)');
  const classes = useStyles();

  if (!visible || !smartphoneDetected) {
    return null;
  }

  return (
    <div className={classes.wrapper}>
      <div className={classes.innerWrapper}>
        <div className={classes.contentWrapper}>
          <img src={mobileWarningImage} alt="Mobile Warning" />
          <h2 className={classes.headingText}>
            Please visit the Provider Dashboard from a computer
          </h2>
          <p className={classes.descriptionText}>
            The Provider Dashboard isn’t currently supported on mobile. Please visit
            <span className={classes.colorfulText}> chat.joinmodernhealth.com </span>
            on desktop web using Chrome to manage your clients.
          </p>
        </div>

        <MHButton
          buttonWrapperExtraClasses={[classes.buttonWrapper]}
          extraClasses={[classes.button]}
          onClick={() => setVisible(false)}
        >
          Send me to mobile web anyway
        </MHButton>
      </div>
    </div>
  );
};
